<template>
    <div>
    <div v-if="confirmedUserAnswer" class="container-reset-password">
    <div tabindex="0" class="e-card">
      <div class="e-card-title"> Update Password </div>
      <div class="e-card-content margin-color-verify-section">
        <web-login-info
                        ref="refwebLoginInfo"
                        :userProfileId="userId"
                        :userProfilesData="getUserDetail" />
        <div class="align-center-bottom">
          <ejs-button v-on:click.native="onCancelButtonClick"
                        cssClass="e-danger margin-button">Cancel</ejs-button>
          &nbsp;&nbsp;
          <ejs-button type="button" v-on:click.native="btnComplete"
                        cssClass="e-info margin-button">Submit</ejs-button>
        </div>
      </div>
      </div>
      </div>
    </div>
    </template>

<script>
import WebLoginInfo from '../../user-accounts/components/web-login-info.vue';

export default {
  name: 'ResetPasswordSCC',
  components: {
    WebLoginInfo,
  },
  data() {
    return {
      confirmedUserAnswer: true,
    };
  },
  created() {
  },
  computed: {
    confirmedUserName() {
      return this.$store.getters.confirmedUserName;
    },
    getUserDetail() {
      return this.$store.getters.confirmedUser;
    },
    userId() {
      return this.$store.getters.confirmedUser.userId;
    },
  },
  methods: {
    notify(type, message) {
      this.$parent.notificationToasts.push({
        title: type,
        content: message,
        cssClass: type === 'Error' ? 'e-toast-danger' : 'e-toast-success',
        timeOut: 5000,
      });
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
    },
    onCancelButtonClick() {
      this.$router.push('/');
    },
    btnComplete() {
      const loginInfo = this.$refs.refwebLoginInfo;
      let notificationContent = '';
      // --Leo. this loginInfo.isConfirmPassword always return ture.
      // -- not fixed, just bring showConfirmPasswordMatch to join check for now.
      if (!loginInfo.isPasswordValid || !loginInfo.isConfirmPassword
        || !loginInfo.showConfirmPasswordMatch) {
        notificationContent = 'Please enter correct passwod.<br>';
      }

      if (loginInfo.isPasswordValid && loginInfo.isConfirmPassword) {
        loginInfo.resetPassword();
        notificationContent += "password has successfully changed;";
        this.notify('Success', notificationContent);
        this.$router.push('/login');
      } else {
        loginInfo.validatePassword();
        this.notify("Error", notificationContent);
      }
    },
  },
};
</script>
    <style>
    .container-reset-password {
      padding: 16px 10% 16px 10%;
    }
    </style>
